import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import { initErrorTracking } from './lib/errorTracking';
import { registerServiceWorker } from './lib/pwaInstall';
import { initNativePush } from './lib/nativePush';
import './index.css';
import './dark-mode-shim.css'; // must come after index.css so dark overrides win specificity
import App from './App';

// Init error tracking before the first render so Sentry captures bootstrap
// errors. Fully no-op when REACT_APP_SENTRY_DSN is unset.
initErrorTracking();
registerServiceWorker();
// No-op on plain web; only runs when Capacitor's native runtime is present.
initNativePush();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);
